import getEsriData from "context/contextFunctions/getEsriData";

// eslint-disable-next-line consistent-return
export default async function getSectors({
  layerId,
  dispatch,
  sectors,
  token,
}) {
  if (!sectors && layerId !== undefined) {
    const query = `1=1`;
    const { res } = await getEsriData({
      token,
      layerId,
      layer: process.env.REACT_APP_DLS_Lockups_Table,
      outFields: "HOD_CODE,VILL_CODE,SECT_CODE, SECT_ANAME",
      returnDistinctValues: true,
      featureOrMap: "MapServer",
      returnGeometry: false,
      query,
    });
    dispatch({ type: "INIT", payload: { sectors: res } });
    return res;
  }
}
